import React, {useState, useEffect} from 'react';
import Button from '../Button/Button';
import { Block } from '../../styles/commons'
import InputCell from '../InputCell/InputCell'
import {
  Container,
  Row,
  Col,
} from 'reactstrap';

import {useErrorToast} from '../../hooks/useErrorToast';
import Layout from '../Layout/Layout'
import {useFormValidation} from '../../hooks/useFormValidation';
import portal from '../../stacks/portal/PortalAWS';
import searchCriteria from '../../data/searchCriteria'

const portalAPI  = portal.getInstance()

const SourceOfFundsUserScreen = props => {
  const {resetInitialURL} = props

  const clearForm = {
    description: '',
    companyIndustry: '',
    yearIncorporated: '',
    employees: '',
    round: [],
    regType: [],
    securityTypes: [],
    industryNaics: [],
    legalForm: [],
    fundingAmountCurrency: [],
    revenueProducing: [],
    profit: [],
    city: '',
    stateOrCountry: '',
    allowUnsolicitedMessages: 'yes'
  }
    
  const [, setLoading] = useState(false)
  const [, setLoadingMsg] = useState('')
  const [form,setForm] = useState(clearForm)
  const [isDirty, setIsDirty] = useState(false)
  // const [isAdmin, setIsAdmin] = useState(false)
  const {setErrorMsg,errorToast} = useErrorToast('');
  const {validated} = useFormValidation(form,[
    'yearIncorporated',
  ]);
  
  const controlled = {
    form,
    setForm,
    setIsDirty,
    validated
  }

  useEffect(() => {
    async function retrieve() {
      try {
        setLoading(true)
        setLoadingMsg('Loading portal search interests ...')
        const interests = await portalAPI.retrieveInterest()
        setForm({...clearForm, ...interests})
        setLoading(false)
        setLoadingMsg('')
      }
      catch(err) {
        setLoading(false)
        setLoadingMsg('')
        setErrorMsg(`Retrieve error: ${JSON.stringify(err.message,null,2)}`);
        console.error(`Retrieve error: ${JSON.stringify(err.message,null,2)}`);
      }
    }
    retrieve()
    resetInitialURL()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  async function store() {
    try {
        setLoading(true)
        setLoadingMsg('Storing portal interest  ...')
        await portalAPI.storeInterest(form)
        setLoading(false)
        setLoadingMsg('')
        setIsDirty(false)
        props.history.push('/')
    }
    catch(err) {
      setLoading(false)
      setLoadingMsg('')
      setErrorMsg(`Store error: ${JSON.stringify(err.message,null,2)}`);
      console.error(`Store error: ${JSON.stringify(err.message,null,2)}`);
    }
  }

  return (
    <Layout>
      <Container>
        <Block>
        <Row>
            <Col>
              <p>
                <a style={{color: 'red', textDecoration: 'underline'}} href='https://youtu.be/eDqYHatJrE0' target='_blank' rel="noreferrer">Please watch this short instructional video to ensure your profile is properly set up.</a>
              </p>
            </Col>
          </Row>
          <Row style={{fontSize: '26px'}}>
          <Col>
            <h2>
              Provide your interest criteria so companies can search for you.
              Items checked or entered restrict your interest.
            </h2>
          </Col>
        </Row>
          <Row>
          <Col>
            {isDirty && <div style={{textAlign: 'right'}}><Button click={store}>STORE</Button></div>}
          </Col>
        </Row>
        <hr/>
        <Row>
          <Col>
          <h2>Allow Unsolicited Messages?</h2>
          <InputCell
              controlled={controlled}
              radio={true}
              checkbox={true}
              label=''
              fieldLabel={['yes', 'no']}
              selectValues={['yes', 'no']}
              name='allowUnsolicitedMessages'
            />
          </Col>
        </Row>
        <hr/>
        <h2>Describe Your Investment Interests:</h2>
          <Row>
            <Col>
              <InputCell controlled={controlled} {...searchCriteria.description}
              label=''
                // label='Describe Your Investment Interests'
                rows={4}
              />
            </Col>
          </Row>
          <hr/>
        <h2>Further Qualify Your Investment Interests:</h2>
        <p/>
          <Row>
          <Col md={6}>
            <InputCell controlled={controlled} {...searchCriteria.city}/>
          </Col>
          <Col md={6}>
            <InputCell controlled={controlled} {...searchCriteria.stateOrCountry}/>
          </Col>
        </Row>
          <Row style={{marginLeft: '10px'}}>
          <Col md={3}>
            <InputCell controlled={controlled} {...searchCriteria.yearIncorporatedRange} />
          </Col>
          <Col md={3}>
            <InputCell
              controlled={controlled}
              {...searchCriteria.employeesRange}
            />
          </Col>
          <Col md={3}>
            <InputCell
              controlled={controlled}
              {...searchCriteria.fundingAmountCurrencyRange}
            />
          </Col>
        </Row>
          <Row style={{marginLeft: '10px'}}>
          <Col md={3}>
              <InputCell
                controlled={controlled}
                {...searchCriteria.round}
                checkbox={true}
                radio={false}
              />
          </Col>
          <Col md={3}>
            <InputCell
              controlled={controlled}
              {...searchCriteria.regType}
              checkbox={true}
              radio={false}
            />
          </Col>
          <Col md={3}>
            <InputCell
              controlled={controlled}
              {...searchCriteria.securityTypes}
              checkbox={true}
              radio={false}
            />
          </Col>
        </Row>
          <Row style={{marginLeft: '10px'}}>
            <Col md={3}>
              <InputCell
              controlled={controlled}
              {...searchCriteria.legalForm}
              checkbox={true}
              radio={false}
              />
            </Col>
            <Col md={3}>
              <InputCell
                controlled={controlled}
                {...searchCriteria.revenueProducing}
                checkbox={true}
                radio={false}
              />
            </Col>
            <Col md={3}>
              <InputCell
                controlled={controlled}
                {...searchCriteria.profitable}
                checkbox={true}
                radio={false}
              />
            </Col>
          </Row>
          <Row style={{marginLeft: '10px'}}>
            <Col md={12}>
              <InputCell
                controlled={controlled}
                {...searchCriteria.industryNaics}
                checkbox={true}
                radio={false}
              />
            </Col>
          </Row>
        </Block>
      </Container>
      {errorToast}
    </Layout>
  );
};

export default SourceOfFundsUserScreen;
